import { useState, useEffect } from 'react';
import { POST_PAYOUT_CUSTOMER_DETAIL } from './../../Utils/appConstants';
import { useHistory } from "react-router-dom";
import PropagateLoader from "react-spinners/PropagateLoader";
import AddCustomer from './addCustomer';
import ViewCustomer from './viewCustomer';
import { postRequest } from '../../Utils/AppApi';
import { toast } from 'react-toastify';
// import { Modal } from 'antd';

const MyComponent = (props) => {
    const history = useHistory();
    // const tabPosition = 'left';
    const [isLoading, setLoading] = useState(false);
    const [searchText, setSearchText] = useState(null);
    const [timer, setTimer] = useState(null);
    const [isCustomerInfo, setCustomerInfo] = useState(null);
    const [isCustomerNotExist, setCustomerNotExist] = useState(false);

    useEffect(() => {
        if (props.mobile) {
            setSearchText(props.mobile)
        }
    }, [props.mobile]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (searchText) {
            if (timer) {
                clearTimeout(timer)
                setTimer(null)
            }
            setTimer(
                setTimeout(() => {
                    if (searchText.length === 10) {
                        // setSearchButton(false)
                        getCustomerInfo()
                    } else {
                        setCustomerNotExist(false);
                        // toast.error("Please enter a valid Mobile Number.")
                    }
                }, 1000)
            )
        }
    }, [searchText]) // eslint-disable-line react-hooks/exhaustive-deps

    const getCustomerInfo = async () => {
        setLoading(true)
        if (!searchText) {
            toast.error("Please enter a Customer Number");
            setLoading(false)
            return false;
        } else if (searchText.length !== 10) {
            toast.error("Please enter a valid Mobile Number");
            setLoading(false)
            return false;
        }
        let payload = { "customerMobile": searchText, "detail_for": "quickSettlement" }
        await postRequest(POST_PAYOUT_CUSTOMER_DETAIL, payload, history).then((response) => {
            if (response.success === true) {


                if(response.data){

                setCustomerInfo(response.data);
                setCustomerNotExist(false);
                }
                else{
                    toast.error(response.message);

                }
                // setReferenceKey(response.data.referenceKey);
                // console.log("----------------", response.data);
            } else {

                setCustomerNotExist(true);


                // setReferenceKey(response.data.referenceKey);
                // console.log("----------------", response.success);
            }
            setLoading(false)
        }).catch(function (error) {
            console.log(error)
            setLoading(false);
        })
    }

    // const handleCustomerVerify = () => {
    //     // console.log("verify ========== ")
    //     if (otpCode) {
    //         setLoading(true)
    //         // console.log("otpCode ===================== ", otpCode)
    //         const payload = {
    //             referenceKey: referenceKey,
    //             otp: otpCode,
    //             customerMobile: searchText,
    //         };

    //         postRequest(`${POST_DMT_INSTANT_PAY_OTP_VERIFICATION}`, payload, history).then((response) => {
    //             if (response.success === true) {
    //                 setOtpModal(false);
    //                 getCustomerInfo();
    //                 toast.success(response.message);
    //             } else {
    //                 toast.error(response.message);
    //             }
    //             setLoading(false)
    //         }).catch(function (error) {
    //             // console.log(error)
    //             setLoading(false)
    //         })
    //     } else {
    //         toast.error("OTP code is required");
    //     }
    // }

    // const onChangeOtpValue = (value) => {
    //     setOtpCode(value);
    // }

    if (isLoading) {
        return <div className="content text-center" style={{ margin: "250px 0" }}>
            <PropagateLoader color="#5851D2" loading={isLoading} size={25} />
        </div>
    }
    return (
        <div>
            <div className="">
                <div className="">
                    {(isCustomerNotExist) && <AddCustomer mobile={searchText} findCustomerInfo={getCustomerInfo} />}
                    {(isCustomerInfo && !isCustomerNotExist) && <ViewCustomer isCustomerInfo={isCustomerInfo} findCustomerInfo={getCustomerInfo} />}
                </div>
            </div>
        </div>
    )
}

export default MyComponent;